import { EventBus, EVENTS } from '@/services/event-bus'

function getLineItems(items) {
  return items.map(item => {
    const lineItem = {
      sku: item.variantSku,
      productSku: item.masterSku,
      productName: item.productName,
      productType: item.productType,
      price: item.price,
      currency: item.currency,
      quantity: item.quantity,
      size: item.displaySize,
    }
    return lineItem
  })
}

export default {
  methods: {
    updateCart(
      selectedSku,
      { context = this.$CONTEXTS.unknown, isGiftCardOrder = false, giftCardMessage = '' } = {}
    ) {
      if (context !== this.$CONTEXTS.quickView)
        this.$store.dispatch('nav/setAdditionalNav', 'mini-cart')
      this.$store.dispatch('order/updateServer', {
        skuId: selectedSku.productVariantId,
        quantity: 1,
        isGiftCardOrder,
        giftCardMessage,
        onError: message => {
          const text = message || this.$t('minicart.cart_add_fail')
          this.$store.dispatch('flash/addMessage', {
            text,
            type: 'error',
            context: this.$CONTEXTS.miniCart, // always show errors in mini cart context
          })
        },
        onDone: order => {
          const lineItems = getLineItems(order.items)
          const addedItem = lineItems.filter(lineItem => lineItem.sku == selectedSku.sku)[0]
          this.trackAddToCart(lineItems, addedItem, { context })
          this.dispatchAddToCartEvents()
        },
      })
    },

    trackAddToCart(lineItems, addedItem, { context } = {}) {
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.addToCart,
        product: {
          ...addedItem,
          viewmode: context === this.$CONTEXTS.quickView ? this.$CONTEXTS.quickView : '',
        },
      })
      this.$dyClient.trackAddToCart(lineItems, addedItem)
      if (context === this.$CONTEXTS.miniCart) this.$dyClient.trackMinicartAddToCart(addedItem)
    },

    dispatchAddToCartEvents() {
      window.dispatchEvent(new CustomEvent('on:addtocart'))
      EventBus.$emit(EVENTS.minicart.update, { detail: { addToCart: true } })
    },
  },
}
